export default {
  REFERRER_TYPES_REPOSITORY: Symbol.for('REFERRER_TYPES_REPOSITORY'),
  GET_ALL_REFERRER_TYPES_QUERY: Symbol.for('GET_ALL_REFERRER_TYPES_QUERY'),
  REFERRER_TYPES_STATE_MANAGER: Symbol.for('REFERRER_TYPES_STATE_MANAGER'),
};
